"use client";

import { useState } from "react";

export default function MotDePasseOubliePage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      await fetch("/api/auth/forgot-password", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ email }),
      });
      setSent(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="flex-1 flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-sm bg-white border border-slate-200 rounded-2xl shadow-sm p-8">
        <h1 className="text-xl font-bold text-[#07008b] mb-1">Mot de passe oublié</h1>
        {sent ? (
          <p className="text-sm text-slate-500">
            Si un compte existe avec cet email, un lien de réinitialisation vient de lui être envoyé.
          </p>
        ) : (
          <>
            <p className="text-sm text-slate-500 mb-6">
              Indiquez votre email, nous vous envoyons un lien pour choisir un nouveau mot de passe.
            </p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-semibold mb-1" htmlFor="email">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full rounded-lg bg-[#07008b] text-white font-semibold py-2 text-sm disabled:opacity-50"
              >
                {loading ? "Envoi..." : "Envoyer le lien"}
              </button>
            </form>
          </>
        )}
        <a href="/connexion" className="block text-center text-xs text-slate-400 mt-4 underline">
          Retour à la connexion
        </a>
      </div>
    </main>
  );
}
